// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__0Sfvy","title":"styles_title__AIgZn"};